import { createAsyncThunk } from "@reduxjs/toolkit";
import realOrderService from "../../helpers/real_order_helper";
import { Order } from "./reducer";

type CreateOrderData = Omit<Order, "id"> & { id?: number };

export const getOrders = createAsyncThunk("orders/getOrders", async () => {
  const response = await realOrderService.getOrders();
  return response;
});

export const addOrders = createAsyncThunk("orders/addOrders", async (order: CreateOrderData) => {
  const response = await realOrderService.addOrder(order);
  return response;
});

export const updateOrders = createAsyncThunk("orders/updateOrders", async (order: Order) => {
  const response = await realOrderService.updateOrder(order);
  return response;
});

export const deleteOrders = createAsyncThunk("orders/deleteOrders", async (orderId: number) => {
  const response = await realOrderService.deleteOrder(orderId);
  return response;
});

export const syncOrders = createAsyncThunk("orders/syncOrders", async (_, { dispatch }) => {
  const result = await realOrderService.syncPendingOrders();
  if (result.syncedCount > 0) {
    await dispatch(getOrders());
  }
  return result;
});
